import * as Sentry from '@sentry/vue';

import ApiClient from '@/api-client';

export const TIME_CLOCK_STATUS_IN = 'In';
export const TIME_CLOCK_STATUS_LUNCH = 'Lunch';
export const TIME_CLOCK_STATUS_OUT = 'Out';
export default {
    namespaced: true,
    state: {
        user: { roles: [], hrEmployee: {} },
        timeClockStatus: TIME_CLOCK_STATUS_OUT,
    },
    getters: {
        isCustomer(state) {
            return state.user && state.user.type === 'customer';
        },
        isEmployee(state) {
            return state.user && state.user.type === 'employee';
        },
        roles: (state) => state.user.roles || [],
        mappedRoles: (state) => new Map(Object.entries(state.user.roles.reduce((accumulator, value) => ({ ...accumulator, [value]: value }), {}))),
        timeClockEnabled(state) {
            return state.user.time_clock_enabled;
        },
        isClockedIn(state) {
            return state.timeClockStatus === TIME_CLOCK_STATUS_IN;
        },
        isClockedOut(state) {
            return state.timeClockStatus === TIME_CLOCK_STATUS_OUT;
        },
        isOnLunch(state) {
            return state.timeClockStatus === TIME_CLOCK_STATUS_LUNCH;
        },
    },
    mutations: {
        setUser(state, user) {
            Sentry.setUser({ email: user.email, id: user.id, name: user.name });
            Sentry.setTag('version', COMMIT_HASH);
            state.user = user;
        },
        setTimeClockStatus(state, timeClockStatus) {
            state.timeClockStatus = timeClockStatus;
        },
        setStillWorking(state, stillWorking) {
            state.user.still_working = stillWorking;
        },
    },
    actions: {
        async login({ commit }, authCode) {
            try {
                await ApiClient.post('/api/authenticate', { auth_token: authCode });
            } catch (e) {
                commit('setUser', { roles: [], hrEmployee: {} });
                throw (e);
            }
        },
        async logout({ commit }) {
            await ApiClient.post('/api/logout');
            commit('setUser', { roles: [], hrEmployee: {} });
        },
        async getUser({ dispatch }) {
            await dispatch('refreshUser');
        },
        async refreshUser({ commit }) {
            const user = await ApiClient.getItem('/api/user/me');
            commit('setUser', user);
        },
        async timeClockStatus({ commit }, status) {
            commit('setTimeClockStatus', status);
        },
    },
};
